import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface RequestsTypePayload extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_REQUESTS_TYPE;
    id: string;
    attributes: {
      data: Array<{
        request_type: string;
        request_status: string;
        request_count: number;
        request_type_total_count: number;
      }>;
    };
  };
}

export const parseRequestsTypePayload = (
  payload: BaseInsightPayload
): RequestsTypePayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_REQUESTS_TYPE,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      request_type: string;
      request_status: string;
      request_count: number;
      request_type_total_count: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_REQUESTS_TYPE,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
